import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';

type ShadowRootType = {
  htmlView: string | JSX.Element | JSX.Element[];
  styleTagContent?: string;
};

export const ShadowRoot = ({ htmlView, styleTagContent = '' }: ShadowRootType) => {
  const hostRef = useRef(null);

  // We need this state to avoid flicker of already existing ShadowRoot (not unmounted)
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const host = hostRef.current;

    if (host) {
      const shadow = host.attachShadow({ mode: 'open' });

      // Inject Tailwind CSS styles directly into shadow root
      const style = document.createElement('style');
      style.textContent = styleTagContent;

      // We use the rendered {htmlView} in div as its actual view, but this time it's already part of the shadow root
      shadow.innerHTML = host.innerHTML; // Set shadow DOM content
      shadow.appendChild(style); // Append the style to the shadow root
      host.innerHTML = ''; // Clear host content

      setShowContent(true);
    }
  }, []);

  return (
    <div ref={hostRef} className={clsx(showContent && 'tw-visible', !showContent && 'tw-hidden')}>
      {htmlView}
    </div>
  );
};
